// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"121":"0451b51820cef9a7","280":"74391dea9e3c2095"}[chunkId] + ".js";
};